/**
 * Product Horizontal Tabs
 * Handles tab switching for horizontal product tabs
 */

document.addEventListener('DOMContentLoaded', function() {
  const tabsContainers = document.querySelectorAll('[data-tabs-container]');

  tabsContainers.forEach(container => {
    const tabs = container.querySelectorAll('[data-tab-trigger]');
    const panels = container.querySelectorAll('[data-tab-panel]');

    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const targetId = this.getAttribute('data-tab-trigger');

        // Remove active class from all tabs and panels
        tabs.forEach(t => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(p => p.classList.remove('active'));

        // Add active class to clicked tab and corresponding panel
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');

        const targetPanel = container.querySelector(`[data-tab-panel="${targetId}"]`);
        if (targetPanel) {
          targetPanel.classList.add('active');
        }
      });
    });
  });
});
